module.exports = __webpack_public_path__ + "static/sponsor.17b890e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/sponsorship/sponsor.jpg
// module id = 136
// module chunks = 135625081114434 251752240982164